import React, { useState, useEffect, useCallback, useContext } from 'react';
import './styles.css';
import HomeLayout from '../Layouts/homeLayout';
import { getSchedules, saveSchedule, updateSchedule, deleteSchedule } from '../../actions/schedule';
import Button from '@mui/material/Button';
import LoadingView from '../Loader/LoadingView';
import { toast } from 'react-toastify';
import CreateSchedule from './components/add';
import InvitesList from './components/inviteeslist';
import NoData from '../common/noData';
import ConfirmAlert from '../common/confirmAlert';
import { useHistory } from 'react-router-dom';
import { PayloadContext } from '../../context';
import { Calendar } from 'react-date-range';
import { timeFormat, getDuration } from '../../utils';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

const ScheduleSession = () =>
{
	const history = useHistory();
	const [ open, setOpen ] = useState(false);
	const [ list, setList ] = useState({ loading: false, data: [] });
	const [ editObj, setEditObj ] = useState(null);
	const [ deleteId, setDeleteId ] = useState(null);
	const [ isRecurringDeleteId, setIsRecurringDeleteId ] = useState(null);
	const [ recurringId, setrecurringId ] = useState(null);
	const [ isAlertOpen, setIsAlertOpen] = useState(false);
	const [ selectedDate, setSelectedDate ] = useState(new Date());
	const [ invitesList, openInvitees ] = useState(null);
	const [ copiedId, setCopiedId ] = useState(null);
	const [ copiedGuestId, setCopiedGuestId ] = useState(null);
	const handleOpen = () => setOpen(true);

	const { payload } = useContext(PayloadContext);

	const getData = useCallback((from, to) =>
	{
		setList((prevState) => { return { ...prevState, loading: true }; });
		getSchedules(from, to).then((res) =>
		{
			// eslint-disable-next-line no-console
			// console.log('res ==== ', res);
			if (res?.data?.status)
			{
				setList({ loading: false, data: [ ...res.data.data ] });
			}
			else
			{
				setList({ loading: false, data: [] });
			}
		})
			.catch((err) =>
			{
				// eslint-disable-next-line no-console
				console.log('err ==== ', err);
				setList({ loading: false, data: [] });
			});
	}, []);

	useEffect(() =>
	{
		const from = new Date(selectedDate);

		from.setHours(0, 0, 0, 0);
		const to = new Date(selectedDate);

		to.setHours(23, 59, 59);
		getData(from.valueOf(), to.valueOf());
	}, [ getData, selectedDate ]);

	const handleDelete = () =>
	{
		if (deleteId !== null)
		{
			setList((prevState) => { return { ...prevState, loading: true }; });
			deleteSchedule({ id: deleteId,recurringId : recurringId }).then((res) =>
			{
				// eslint-disable-next-line no-console
				// console.log('res ==== ', res);
				if (res && res.status)
				{
					toast.success('Deleted successfully');
					setDeleteId(null);
					setIsRecurringDeleteId(null);
					setrecurringId(null);
					const from = new Date(selectedDate);

					from.setHours(0, 0, 0, 0);
					const to = new Date(selectedDate);

					to.setHours(23, 59, 59);
					getData(from.valueOf(), to.valueOf());
				}
				else
				{
					const msg = res?.data?.message ? res?.data?.message : 'Internal server error, Please try again';

					toast.error(msg);
					setList((prevState) => { return { ...prevState, loading: false }; });
				}
			})
				.catch((err) =>
				{
					// eslint-disable-next-line no-console
					console.log('err ==== ', err);
					toast.error('Internal server error, Please try again');
					setList((prevState) => { return { ...prevState, loading: false }; });
				});
		}
	};

	const handleSave = useCallback((formData) =>
	{
		setList((prevState) => { return { ...prevState, loading: true }; });
		saveSchedule(formData).then((res) =>
		{
			// eslint-disable-next-line no-console
			// console.log('res ==== ', res);
			if (res?.data?.status)
			{
				setOpen(false);
				toast.success('Added successfully');
				const from = new Date(selectedDate);

				from.setHours(0, 0, 0, 0);
				const to = new Date(selectedDate);

				to.setHours(23, 59, 59);
				getData(from.valueOf(), to.valueOf());
			}
			else
			{
				const msg = res?.data?.message ? res?.data?.message : 'Internal server error, Please try again';

				toast.error(msg);
			}
		})
			.catch((err) =>
			{
				// eslint-disable-next-line no-console
				console.log('err ==== ', err);
				toast.error('Internal server error, Please try again');
			});
	}, [ selectedDate, getData ]);

	const handleUpdate = useCallback((id, obj) =>
	{
		setList((prevState) => { return { ...prevState, loading: true }; });
		obj['id'] = id;
		// console.log("obj>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
		// console.log(obj);
		// console.log("obj<<<<<<<<<<<<<<<<<<<<<<<<<");
		updateSchedule(obj).then((res) =>
		{
			// eslint-disable-next-line no-console
			// console.log('res ==== ', res);
			if (res && res.data && res.data.status)
			{
				setEditObj(null);
				toast.success('Updated successfully');
				const from = new Date(selectedDate);

				from.setHours(0, 0, 0, 0);
				const to = new Date(selectedDate);

				to.setHours(23, 59, 59);
				getData(from.valueOf(), to.valueOf());
			}
			else
			{
				const msg = res?.data?.message ? res?.data?.message : 'Internal server error, Please try again';

				toast.error(msg);
				setList((prevState) => { return { ...prevState, loading: false }; });
			}
		})
			.catch((err) =>
			{
				// eslint-disable-next-line no-console
				console.log('err ==== ', err);
				toast.error('Internal server error, Please try again');
				setList((prevState) => { return { ...prevState, loading: false }; });
			});
	}, [ selectedDate, getData ]);

	const handleJoin = (item) =>
	{
		if (item.license && item.license && item.license._id !== '')
		{
			history.push(`/session/${item._id}`);
		}
	};

	// const handleBack = () =>
	// {
	// 	history.push('/dashboard');
	// };

	const handleDeleteClick = (row) => {
	setIsRecurringDeleteId({ id: row._id, recurringId: row.recurringId });
	setIsAlertOpen(true);

	};

	const handleCloseAlert = () => {
	setIsAlertOpen(false);
	// setIsRecurringDeleteId(null);
	};

	const handleDeleteOption = (option) => {

	if (option === 'this') {
	// console.log('Delete this schedule:', isRecurringDeleteId.id);

	} else if (option === 'thisAndFollowing') {
	// console.log("thisAndFollowing");
		setrecurringId(isRecurringDeleteId.recurringId);
	// console.log('Delete this and following schedules:', isRecurringDeleteId.id, isRecurringDeleteId.recurringId);
	}
	handleCloseAlert(isRecurringDeleteId.id);
	setDeleteId(isRecurringDeleteId.id)
	};

	const handleCopyMeetingLink = (item, isGuest = true) => {
		const guestParam = isGuest ? 'guest-session' : 'session';
		const meetingLink = `${window.location.origin}/${guestParam}/${item._id}`;
		navigator.clipboard.writeText(meetingLink).then(() => {
			if (isGuest) {
				toast.success('Guest meeting link copied to clipboard!');
				setCopiedGuestId(item._id);
				setTimeout(() => setCopiedGuestId(null), 2000);
				return;
			} else {
				toast.success('Meeting link copied to clipboard!');
				setCopiedId(item._id);
				setTimeout(() => setCopiedId(null), 2000);
				return;
			}
		}).catch(() => {
			toast.error('Failed to copy meeting link');
		});
	};

	return (
		<div className='flexCol pdngSM fullHeight'>
			<div className='rightButton'>
				{/* <Button variant='contained' size='small'
				color='primary' onClick={() => handleBack()}>Account Center</Button> */}
				<Button variant='contained' size='small' onClick={handleOpen} title='Create Schedule'>Create Schedule</Button>
			</div>
			{list?.loading && <LoadingView />}
			<div className='resRowCol cntnrHeight mrgnTMD'>
				<div className='flexAutoCol resPdngSM'>
					<Calendar className='calender'
						date={selectedDate}
						onChange={(date) => setSelectedDate(date)}
					/>
				</div>
				<div className='flexMinWidthCol resPdngSM sessionsList mrgnTMD'>
					{list.data.length > 0 ?
						list.data && list.data.map((row) =>
						{
							const et = new Date(row.startTime);

							et.setMinutes(et.getMinutes() + Number(row.duration));
							const now = new Date().valueOf();
							const early = new Date();

							early.setMinutes(early.getMinutes() + 10);

							return (
								<div key={row._id} className='pdngVSM'>
									<div className='resRowCol pdngSM brdrRadiusSM scheduleList'>
										<div className='resColRowAuto justifyCntr alignCntr pdngSM dateView'>
											<div className='flexAutoRow pdngHSM resAlignCntr'>
												<span>{new Date(row.startTime).toLocaleString('en-US', {
													month : 'long',
													day   : '2-digit',
													year  : 'numeric'
												})}</span>
												{/* <span>{new Date(row.startTime).toLocaleString('en-IN', {
													day   : '2-digit',
													month : 'short' })}</span> */}
											</div>
											{/* <div className='flexAutoRow pdngHSM resAlignCntr'>
												<span>{new Date(row.startTime).toLocaleString('en-US', {
													year : 'numeric' })}</span>
											</div> */}
										</div>
										{/* <div className='flexAutoRow pdngHSM resAlignCntr'>
											<span>{new Date(row.startTime).toLocaleString('en-US', {
												year : 'numeric' })}</span>
										</div> */}
										<div className='flexMinWidthCol pdngSM'>
											<h4 className='mrgnBSM'>{row.meetingName}</h4>
											<span>Start Time: {timeFormat(row.startTime)}</span>
											<span>Duration: {getDuration(row.duration)}</span>
											<span>Room: {row?.license?.name ? row?.license?.name : '--'}</span>
										</div>
										<div className='flexAutoRow pdngSM actionBtnSection'>
											<Button disableElevation size='small' onClick={() => handleCopyMeetingLink(row, false)}>
												{copiedId === row._id ? 'Copied' : 'Copy Link'}
											</Button>
											<Button disableElevation size='small' onClick={() => handleCopyMeetingLink(row, true)}>
												{copiedGuestId === row._id ? 'Copied' : 'Copy Guest Link'}
											</Button>
											{row.startTime >= now && <>
												<Button disableElevation size='small' onClick={() => setEditObj(row)}>Edit</Button>
												{row.isRecurring =="true" ? (
												<Button disableElevation size="small" onClick={() => handleDeleteClick(row)}>
												Delete
												</Button>
												) : (
												<Button disableElevation size="small" onClick={() => setDeleteId(row._id)}>
												Delete
												</Button>
												)}
											</>}
											{((row.startTime <= now && now <= et) ||
												(row.userId === payload._id && row.startTime <= early.valueOf()
												&& early.valueOf() <= et)) && <Button disableElevation size='small' onClick={() => handleJoin(row)}>Join</Button>
											}
											{(row.userId === payload._id /*|| payload.userType === 'Admin'*/) && row.invites && row.invites.length > 0 && <Button disableElevation size='small' onClick={() => openInvitees([ ...row.invites ])}>Invitees</Button>}
										</div>
									</div>
								</div>
							);
						})
						: <NoData nodata='No Schedules'/>}
				</div>
			</div>
			{(open || editObj !== null) &&
			<CreateSchedule
				open={open || editObj !== null}
				handleClose={() =>
				{
					setOpen(false);
					setEditObj(null);
				}
				}
				handleSave={handleSave}
				data={editObj}
				handleUpdate={handleUpdate}
			/>}
			{deleteId !== null &&
			<ConfirmAlert
				open={deleteId !== null}
				content='Do you really want to delete the Schedule?'
				handleOk={handleDelete}
				handleCancel={() => setDeleteId(null)}
			/>
			}
			{isRecurringDeleteId !== null &&
				<Dialog open={isAlertOpen} onClose={handleCloseAlert}>
				<DialogTitle>Confirm Deletion</DialogTitle>
				<DialogContent>
				<p>What would you like to delete?</p>
				</DialogContent>
				<DialogActions>
				<Button onClick={() => handleDeleteOption('this')} color="primary">
				This schedule
				</Button>
				<Button onClick={() => handleDeleteOption('thisAndFollowing')} color="primary">
				This and following schedules
				</Button>
				<Button onClick={handleCloseAlert} color="secondary">
				Cancel
				</Button>
				</DialogActions>
				</Dialog>
			}
			{invitesList && invitesList.length > 0 &&
				<InvitesList
					open={invitesList && invitesList.length > 0}
					handleClose={() =>
					{
						openInvitees(null);
					}
					}
					data={invitesList}
				/>
			}
		</div>
	);
};

export default HomeLayout(ScheduleSession);
